<div class="flex flex-row justify-between items-start gap-8 mt-1 mb-1">
  <rfc-title-widget [titleWidget]="defineTitleAndDescriptionWidgetObj('manage_customer_service')"
    class="flex-1"></rfc-title-widget>

  <mat-icon class="cursor-pointer hover:opacity-70 transition-opacity" *ngIf="!!dialogRef.id && closable"
    (click)="onClose()">close</mat-icon>
</div>

<div *ngIf="!!!customerRetrieved">
  <div [formGroup]="salesForm" class="flex flex-col md:flex-row justify-around items-center gap-4 mt-1 mb-1">
    <mat-form-field appearance="fill" class="w-full md:w-1/2">
      <mat-label>{{ "identification" | i18n }}</mat-label>

      <mat-select formControlName="salesId" ngDefaultControl *ngIf="profiles.sl_references.length > 1">
        <mat-option *ngFor="let id of salesIds" [value]="id">
          {{ id | i18n }}
        </mat-option>
      </mat-select>

      <input *ngIf="profiles.sl_references.length === 1" matInput [value]="salesSelected" disabled="true" />
    </mat-form-field>
  </div>

  <div class="flex flex-col-reverse md:flex-row justify-center items-center gap-8 mt-1 mb-1">
    <button *ngIf="!!!closable" mat-raised-button (click)="onLogout()" class="ald-mat-button w-full md:w-auto px-10">
      {{ "logout" | i18n }}
    </button>
  </div>
</div>

<div class="mt-4">
  <ald-sales-choose-table class="block w-full" (selectedSales)="selectedSales($event)"
    [salesSelected]="salesSelected"></ald-sales-choose-table>
</div>